module.exports = __webpack_public_path__ + "media/images/client-arnold-1ea08bdd8ccd9b2214eefd3c8b07b827.svg";